"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var normalizr_1 = require("normalizr");
var lodash_1 = require("lodash");
var schema_1 = require("./schema");
var IGNORED_ENTITIES = ['oddsStatisticBets'];
function normalizeEntity(data, schema) {
    var entityName = Object.keys(data)[0];
    var entity = data[entityName];
    var targetSchema = schema || schema_1.selectSchema(entityName, lodash_1.isArray(entity));
    if (!targetSchema)
        return data;
    var _a = normalizr_1.normalize(data[entityName], targetSchema), entities = _a.entities, result = _a.result;
    return { entities: lodash_1.omit(entities, IGNORED_ENTITIES), result: result };
}
exports.default = normalizeEntity;
//# sourceMappingURL=normalize.js.map